/**
 * Format vehicle description by removing make, model, and trim.
 * Handles various case formats (uppercase, lowercase, mixed).
 * @param {Object} vehicle - Vehicle object with vehicleDescription, vehicleMake, vehicleModel, vehicleTrim
 * @returns {string} Formatted description
 */
export function formatVehicleDescription(vehicle) {
  const removeDetails = ['vehicleMake', 'vehicleModel', 'vehicleTrim'];
  let { vehicleDescription } = vehicle || {};

  if (!vehicleDescription) {
    return '';
  }

  removeDetails.forEach((detail) => {
    if (vehicle[detail]) {
      vehicleDescription = vehicleDescription.replace(vehicle[detail], '');
      vehicleDescription = vehicleDescription.replace(vehicle[detail].toUpperCase(), '');
      vehicleDescription = vehicleDescription.replace(vehicle[detail].replace(' ', '').toUpperCase(), '');
      vehicleDescription = vehicleDescription.replace(vehicle[detail].toLowerCase(), '');
    }
  });

  return vehicleDescription;
}
